import { useAuthMutation } from 'features/common/apiUtils/queryHelper';
import { groupsApiConfig } from './config';
import { CreateGroupPayload, GroupResponse } from './types';
import { AxiosResponse } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';

const {
  create_group: { scope, url },
  get_groups: { queryKey },
} = groupsApiConfig;

export const useCreateGroup = (
  mutationOptions?: Omit<
    UseMutationOptions<
      AxiosResponse<GroupResponse>,
      unknown,
      CreateGroupPayload,
      unknown
    >,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();
  return useAuthMutation(
    (axiosInstance) => (payload: CreateGroupPayload) =>
      axiosInstance?.post<GroupResponse>(url, payload),
    {
      ...mutationOptions,
      onSuccess: () => {
        queryClient.invalidateQueries(queryKey);
      },
    },
    scope,
  );
};
